import React, { useEffect } from 'react';
// import ServicesButtonList from '../components/ServicesButtonList';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Schema from './Schema';
import ServiceNavigator from './ServiceNavigator';

const SolarSystemRepairs = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="font-sans text-gray-900 bg-gray-100">
    <Schema />
      {/* Hero Section with Black Background */}
      <section
        className="flex flex-col items-center gap-8 mt-16 mb-16 bg-black text-white rounded-3xl overflow-hidden mx-4 sm:mx-auto py-20 max-w-6xl text-center"
        data-aos="fade-up"
      >
        <div className="w-full max-w-3xl">
          <h2 className="text-5xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Solar System Repairs
          </h2>
          <p className="text-xl sm:text-2xl text-gray-300 mb-4 italic">
            Certified Experts in PV On-Grid System Servicing – Sri Lanka’s Most Trusted Repair Team
          </p>
        </div>
      </section>

      {/* Intro Paragraph */}
      <section
        className="px-6 max-w-4xl mx-auto text-gray-700 text-lg sm:text-xl leading-relaxed mb-14 text-justify"
        data-aos="fade-up"
      >
        <p>
          At <strong>Solar Care International</strong>, we specialize in{' '}
          <em>on-site repair and preventive maintenance</em> of{' '}
          <strong>grid-tied solar PV systems</strong>. With over a decade of experience
          and recognition as <strong>Sri Lanka’s No.1 solar maintenance provider</strong>,
          we serve <em>domestic, commercial, and utility-scale systems</em> across the island.
        </p>
      </section>

      {/* What We Offer Section */}
      <section
        className="px-6 max-w-4xl mx-auto mb-20"
        data-aos="fade-right"
      >
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-black">What We Offer</h2>

        {[
          {
            title: 'Expert Diagnostics',
            points: [
              'Real-time inverter log access, insulation resistance tests, and thermal imaging.',
            ],
          },
          {
            title: 'Comprehensive Repairs',
            points: [
              'Fix, replace, or reconfigure system components to restore full performance.',
            ],
          },
          {
            title: 'Certified Engineers',
            points: [
              'SLSEA-compliant service protocols and licensed technicians.',
            ],
          },
          {
            title: '40,000+ kW Experience',
            points: [
              'Trusted by corporates, homeowners, and solar investors.',
            ],
          },
        ].map(({ title, points }, i) => (
          <article key={i} className="mb-10">
            <h3 className="text-xl font-semibold mb-4 text-black">{title}</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-1 text-base">
              {points.map((point, idx) => (
                <li key={idx}>{point}</li>
              ))}
            </ul>
          </article>
        ))}
      </section>

      {/* Media Gallery Section */}
      <section className="px-6 py-20 max-w-6xl mx-auto space-y-16" data-aos="fade-up">
        <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-center text-black">
          On-Site Repairs in Action
        </h2>

        {/* Video Row */}
        <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
          <video
            src="https://res.cloudinary.com/dwf8ifbzs/video/upload/v1751366053/WhatsApp_Video_2025-06-15_at_4.07.16_PM_it2zj5.mp4"
            className="rounded-3xl shadow-xl w-full object-cover"
            autoPlay
            muted
            loop
            playsInline
          />
        </div>

        {/* Image Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          <img
            src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751366181/WhatsApp_Image_2025-06-15_at_4.06.10_PM_1_mhx7no.jpg"
            alt="Solar technician inspecting wiring on rooftop panel"
            className="rounded-3xl shadow-lg w-full h-[300px] object-cover hover:scale-105 transition-transform duration-300"
          />
          <img
            src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751366183/WhatsApp_Image_2025-06-15_at_4.06.01_PM_m4zoye.jpg"
            alt="Panel inspection during repair at a residential installation"
            className="rounded-3xl shadow-lg w-full h-[300px] object-cover hover:scale-105 transition-transform duration-300"
          />
          <img
            src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751366187/WhatsApp_Image_2025-06-15_at_4.05.50_PM_yuyaiq.jpg"
            alt="Close-up of damaged junction box before replacement"
            className="rounded-3xl shadow-lg w-full h-[300px] object-cover hover:scale-105 transition-transform duration-300"
          />
          <img
            src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751366187/WhatsApp_Image_2025-06-15_at_4.06.05_PM_devkwp.jpg"
            alt="Technician performing module-level testing"
            className="rounded-3xl shadow-lg w-full h-[300px] object-cover hover:scale-105 transition-transform duration-300"
          />
        </div>
          <div className="flex justify-center items-center">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              <video
                src="https://res.cloudinary.com/dwf8ifbzs/video/upload/v1751366130/WhatsApp_Video_2025-06-15_at_4.07.14_PM_uyswdy.mp4"
                className="rounded-3xl shadow-xl w-full max-w-md object-cover"
                autoPlay
                muted
                loop
                playsInline
              />
            </div>
          </div>
      </section>




      {/* Our Repair Services Include (grid pill-list) */}
      <section
        className="px-6 max-w-4xl mx-auto mb-20"
        data-aos="fade-up"
      >
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-black text-center">
          Our Repair Services Include
        </h2>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 text-base text-black leading-relaxed w-full max-w-4xl mx-auto">
          {[
            'Inverter troubleshooting & replacements (ABB, SOLIS, SUNGROW, HUAWEI, SOLAR EDGE, SMA, Fronius, Growatt, etc.)',
            'Panel degradation diagnostics and module replacement',
            'Rewiring of DC & AC sides with correct sizing & conduit protection',
            'Correcting MC4 connector faults and surge protection integration',
            'Re-aligning panel mounting structures for wind-load resistance',
            'Replacing rusted isolators, MCBs, SPD units, and damaged junction boxes',
            'Repairing or grounding lightning protection systems',
          ].map((item, i) => (
            <li
              key={i}
              className="bg-white rounded-full px-6 py-3 text-center"
              data-aos="fade-up"
            >
              {item}
            </li>
          ))}
        </ul>
      </section>

      {/* Contact Section with Black Background */}
      <section
        className="flex flex-col items-center gap-8 mt-16 mb-16 bg-black text-white rounded-3xl overflow-hidden mx-4 sm:mx-auto py-20 max-w-6xl text-center"
        data-aos="fade-up"
      >
        <div className="w-full max-w-2xl">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8">
            Book Your System Repair Service
          </h2>
          <div className="w-full max-w-2xl">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8">
            Get in Touch
          </h2>
          <p className="mb-2 font-medium">Solar Care International Pvt Ltd</p>
          <p className="mb-1">No.44/1A, Chapel Lane, Nugegoda, Sri Lanka</p>
          <p className="mb-1">+94 114 199 225 / +94 777 129 021</p>
          <p>
            <a
              href="mailto:info@solarcareinternational.com"
              className="text-blue-400 hover:text-blue-200 underline transition"
            >
              info@solarcareinternational.com
            </a>
          </p>
        </div>
        </div>
      </section>

      {/* <ServicesButtonList /> */}
      <ServiceNavigator />
    </div>
  );
};

export default SolarSystemRepairs;